export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;

export const rowData: Array<any> = [
  {
    fieldName: 'name',
    width: '25%',
  }, {
    fieldName: 'class',
    width: '25%',
  }, {
    fieldName: 'group',
    width: '25%',
  }, {
    fieldName: 'days',
    width: '25%',
    // disabled: true,
    numerical: true,
  },
];

export const contentData: Array<any> = [

];
